export default {
  helperBlockTitle: {
    id: 'merchant_onboarding_home_helper_block_title',
    defaultMessage: 'Need help?',
  },
  helperBlockContact: {
    id: 'bo_seller.onboarding.home.helper_block_contact',
    defaultMessage:
      "We've got articles to support you from beginning to end. {activationEmailLink, html}",
  },
  helperBlockLinkLabel: {
    id: 'bo_seller.onboarding.home.helper_block_link_label',
    defaultMessage: 'Check them out now',
  },
}
